// 1. Define route components.
// These can be imported from other files
import Drawer from '../components/Drawer.vue'
import Dashboard from '../views/Dashboard.vue'
import Units from '../views/Units.vue'
import Signup from '../views/Signup.vue'
import Login from '../views/Login.vue'
import Payments from '../views/transactions/Payments.vue'
import PaymentsV2 from '../views/transactions/PaymentsV2.vue'
import Complaints from '../views/Complaints.vue'
import Bed from '../views/Bed.vue'
import Reservations from '../views/Reservations.vue'
import Forms from '../views/Forms.vue'
import Tenants from '../views/Tenants.vue'
import Announcements from '../views/Announcements.vue'
import Account from '../views/Account.vue'
import ActivateAccount from '../views/ActivateAccount.vue'
import CreateProperty from '../views/CreateProperty.vue'
import Admin from '../views/Admin.vue'
import ComingSoon from '../components/ComingSoon.vue'
import Property from '../views/Property.vue'
import Violations from '../views/Violations.vue'
import User from '../views/User.vue'
import AddEmergencyContact from '../views/AddEmergencyContact.vue'
import Calendar from '../views/Calendar.vue'
import ForgotPassword from '../views/ForgotPassword.vue'
import ResetPassword from '../views/ResetPassword.vue'
import Custom from '../views/Custom.vue'
import Checkout from '../views/Checkout.vue'
import UpdateEmail from '../views/UpdateEmail.vue'
import Expired from '../views/Expired.vue'
import PDCs from '../views/transactions/PDCs.vue'
import AddMultiplePDC from '../components/pdc/AddMultiplePDC.vue'
import PreviewMultiplePayments from '../views/PreviewMultiplePayments.vue'
import BatchImportTenantPreview from '../views/BatchImportTenantPreview.vue'
import BatchImportUnitsPreview from '../views/BatchImportUnitsPreview'
import BatchImportPDCPreview from '../views/BatchImportPDCPreview'
import SecurityDeposit from '../views/transactions/SecurityDeposit'
import DownPayment from '../views/transactions/DownPayment'
import AsyncJob from '../views/AsyncJob.vue'
// const Landing = require('../../public/Landing/index.html')

import guest from './middleware/guest'

// 2. Define some routes
// Each route should map to a component. The "component" can
// either be an actual component constructor created via
// `Vue.extend()`, or just a component options object.
// We'll talk about nested routes later.
const routes = [
  // {
  //   path: '/',
  //   name: 'landing',
  //   component: { template: Landing },
  //   meta: {
  //     skipAuth: true,
  //     middleware: [
  //       guest,
  //     ]
  //   }
  // },
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/signup',
    name: 'signup',
    component: Signup,
    meta: {
      skipAuth: true,
      middleware: [guest]
    }
  },
  {
    path: '/new',
    name: 'createProperty',
    components: {
      default: CreateProperty
    },
    meta: {
      skipPropertyCheck: true
    }
  },
  {
    path: '/comingsoon',
    name: 'comingsoon',
    components: {
      default: ComingSoon
    },
    meta: {
      skipPropertyCheck: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      skipAuth: true,
      middleware: [guest]
    }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    components: {
      default: Dashboard,
      drawer: Drawer
    },
    meta: {
      lessorOnly: true
    }
  },
  {
    path: '/units',
    name: 'units',
    components: {
      default: Units,
      drawer: Drawer
    },
    meta: {
      lessorOnly: true
    }
  },
  {
    path: '/payments',
    name: 'payments',
    components: {
      default: Payments,
      drawer: Drawer
    },
    meta: {
      lessorOnly: true
    }
  },
  {
    path: '/payments-split',
    name: 'payments',
    components: {
      default: PaymentsV2,
      drawer: Drawer
    },
    meta: {
      lessorOnly: true
    }
  },
  {
    path: '/complaints',
    name: 'complaints',
    components: {
      default: Complaints,
      drawer: Drawer
    },
    meta: {
      lessorOnly: true
    }
  },
  {
    path: '/bed/:bedId',
    name: 'unit',
    props: {
      default: true
    },
    components: {
      default: Bed,
      drawer: Drawer
    },
    meta: {
      lessorOnly: true
    }
  },
  {
    path: '/reservations',
    name: 'reservations',
    components: {
      default: Reservations,
      drawer: Drawer
    },
    meta: {
      lessorOnly: true
    }
  },
  {
    path: '/forms',
    name: 'forms',
    components: {
      default: Forms,
      drawer: Drawer
    },
    meta: {
      lessorOnly: true
    }
  },
  {
    path: '/tenants',
    name: 'tenants',
    components: {
      default: Tenants,
      drawer: Drawer
    },
    meta: {
      lessorOnly: true
    }
  },
  {
    path: '/announcements',
    name: 'announcements',
    components: {
      default: Announcements,
      drawer: Drawer
    },
    meta: {
      lessorOnly: true
    }
  },
  {
    path: '/account',
    name: 'account',
    components: {
      default: Account,
      drawer: Drawer
    },
    meta: {
      lessorOnly: true
    }
  },
  {
    path: '/activate/:code',
    name: 'activate',
    component: ActivateAccount,
    props: true,
    meta: {
      skipAuth: true,
      middleware: [guest]
    }
  },
  {
    path: '/admin',
    name: 'admin',
    components: {
      default: Admin,
      drawer: Drawer
    },
    meta: {
      lessorOnly: true
    }
  },
  {
    path: '/property',
    name: 'property',
    components: {
      default: Property,
      drawer: Drawer
    },
    meta: {
      lessorOnly: true
    }
  },
  {
    path: '/violations',
    name: 'violations',
    components: {
      default: Violations,
      drawer: Drawer
    },
    meta: {
      lessorOnly: true
    }
  },
  {
    path: '/user/:username',
    name: 'user',
    props: {
      default: true
    },
    components: {
      default: User,
      drawer: Drawer
    }
  },
  {
    path: '/addEmergencyContact',
    name: 'addEmergencyContact',
    components: {
      default: AddEmergencyContact
    },
    meta: {
      skipPropertyCheck: true
    }
  },
  {
    path: '/calendar',
    name: 'calendar',
    components: {
      default: Calendar,
      drawer: Drawer
    },
    meta: {
      lessorOnly: true
    }
  },
  {
    path: '/forgotpassword',
    name: 'forgotpassword',
    components: {
      default: ForgotPassword
    },
    meta: {
      skipAuth: true,
      skipPropertyCheck: true
    }
  },
  {
    path: '/resetpassword/:code',
    name: 'resetpassword',
    component: ResetPassword,
    props: true,
    meta: {
      skipAuth: true,
      middleware: [guest]
    }
  },
  {
    path: '/custom',
    name: 'custom',
    components: {
      default: Custom,
      drawer: Drawer
    },
    meta: {
      lessorOnly: true
    }
  },
  {
    path: '/checkout/:objectId',
    name: 'checkout',
    component: Checkout,
    props: true,
    meta: {
      skipAuth: true,
      skipPropertyCheck: true
    }
  },
  {
    path: '/updateEmail/:username',
    name: 'updateEmail',
    component: UpdateEmail,
    props: true,
    meta: {
      skipAuth: true,
      skipPropertyCheck: true
    }
  },
  {
    path: '/expired',
    name: 'expired',
    components: {
      default: Expired
    },
    meta: {
      skipPropertyCheck: true
    }
  },
  {
    path: '/pdcs',
    name: 'PDCs',
    components: {
      default: PDCs,
      drawer: Drawer
    },
    meta: {
      lessorOnly: true
    }
  },
  {
    path: '/addMultiplePDC',
    name: 'AddMultiplePDC',
    components: {
      default: AddMultiplePDC,
      drawer: Drawer
    },
    meta: {
      lessorOnly: true
    }
  },
  {
    path: '/preview-multiple-payments',
    name: 'PreviewMultiplePayments',
    components: {
      default: PreviewMultiplePayments,
      drawer: Drawer
    },
    meta: {
      lessorOnly: true
    }
  },
  {
    path: '/tenants/preview-batch-import',
    name: 'BatchImportTenantPreview',
    components: {
      default: BatchImportTenantPreview,
      drawer: Drawer
    },
    meta: {
      lessorOnly: true
    }
  },
  {
    path: '/units/preview-batch-import',
    name: 'BatchImportUnitsPreview',
    components: {
      default: BatchImportUnitsPreview,
      drawer: Drawer
    },
    meta: {
      lessorOnly: true
    }
  },
  {
    path: '/pdcs/preview-batch-import',
    name: 'BatchImportPDCPreview',
    components: {
      default: BatchImportPDCPreview,
      drawer: Drawer
    },
    meta: {
      lessorOnly: true
    }
  },
  {
    path: '/security-deposits',
    name: 'SecurityDeposit',
    components: {
      default: SecurityDeposit,
      drawer: Drawer
    },
    meta: {
      lessorOnly: true
    }
  },
  {
    path: '/down-payments',
    name: 'DownPayment',
    components: {
      default: DownPayment,
      drawer: Drawer
    },
    meta: {
      lessorOnly: true
    }
  },
  {
    path: '/asyncJobs/:id',
    name: 'AsyncJob',
    components: {
      default: AsyncJob,
      drawer: Drawer
    },
    meta: {
      lessorOnly: true
    }
  }
]

export default routes
